export default {
  push: dataFn => {
    if (typeof dataLayer !== 'undefined') {
      const gaProps = dataFn(dataLayer)?.googleAnalytics?.props;
      dataLayer.push(gaProps);
    }
  }
};